const aiCaseSummaryFeedbackConfig = {
  name: 'AI Case Summary Feedback',
  endpoint: '/internal_admin/admin_kit/ai_case_summary_feedbacks',

  columns: [
    { name: 'sentiment', title: 'Sentiment', type: 'link' },
    { name: 'dealer_id', title: 'Dealer ID' },
    { name: 'audience', title: 'Audience' },
    { name: 'case_summary_id', title: 'Case Summary ID' },
    { name: 'comment', title: 'Comment' },
    { name: 'created_at', title: 'When' },
  ],

  filters: [
    { name: 'q[dealer_id_cont]', label: 'Dealer ID' },
    {
      name: 'q[sentiment_eq]',
      label: 'Sentiment',
      options: () => [
        { id: 'up', label: 'Up', value: 'up' },
        { id: 'down', label: 'Down', value: 'down' },
      ],
    },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'case_summary_id', label: 'Case Summary ID' },
    { name: 'estimate_id', label: 'Estimate ID' },
    { name: 'user_id', label: 'User ID' },
    { name: 'user_email', label: 'User Email' },
    { name: 'dealer_id', label: 'Dealer ID' },
    { name: 'audience', label: 'Audience' },
    { name: 'sentiment', label: 'Sentiment' },
    { name: 'comment', label: 'Comment' },
    { name: 'created_at', label: 'When' },
  ],
};

export default aiCaseSummaryFeedbackConfig;
